/**
 * Attribute tooltip
 *
 * Toggles the explanation shown below the swatches of a variation attribute.
 * Hovering is handled in CSS, but that leaves it unreachable on touch devices,
 * so a tap toggles the `is-open` class instead.
 *
 * Handlers are delegated from the document because WooCommerce re-renders the
 * variations form whenever a variation is picked.
 */

import $ from 'jquery';

$(function () {
    function closeAll() {
        $('.attribute-tooltip').removeClass('is-open');
        $('.attribute-tooltip__trigger').attr('aria-expanded', 'false');
    }

    function toggle(trigger) {
        const $tooltip = $(trigger).closest('.attribute-tooltip');
        const wasOpen = $tooltip.hasClass('is-open');

        closeAll();
        $tooltip.toggleClass('is-open', !wasOpen);
        $(trigger).attr('aria-expanded', String(!wasOpen));
    }

    $(document).on('click', '.attribute-tooltip__trigger', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggle(this);
    });

    $(document).on('keydown', '.attribute-tooltip__trigger', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle(this);
        }
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.attribute-tooltip').length) {
            closeAll();
        }
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            closeAll();
        }
    });
});
